import useInfiniteFetch from '@hooks/useInfiniteFetch';

const useLMPSessionsInfo = (goalUID, state) => {
  const key = `v2/live_interaction/learner/sessions/?goal_uid=${goalUID}&state=${state}`;

  const {
    data = [],
    size,
    setSize,
    ...rest
  } = useInfiniteFetch(
    goalUID && state ? key : null,
    {
      applyOffsetsAutomatically: false,
      hasQueryParams: true
    },
    { revalidateOnMount: true }
  );

  const loadMore = () => setSize(size + 1);

  return {
    lmpSessionsInfo: data,
    loadMore,
    ...rest
  };
};

export default useLMPSessionsInfo;
